import {
  Chart,
  Series,
  ValueAxis,
  ArgumentAxis,
  Label,
  Legend,
  Export,
  Format,
  Grid,
  Tooltip,
  Size,
  Title,
} from "devextreme-react/chart";
import { useFetch } from "src/hooks/useFetch";
import { SpatialRun } from "../types";
import {
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
} from "@mui/material";
import { useState } from "react";

const CytoWellSegmentation = ({ run }: { run: SpatialRun }) => {
  const [selectedField, setSelectedField] = useState<string>("CellCount");

  const fieldOptions = [
    { value: "CellCount", label: "Cell Count", precision: 0 },
    {
      value: "CellConfluencyRate",
      label: "Cell Confluency Rate",
      precision: 2,
    },
    { value: "NucleatedCellRate", label: "Nucleated Cell Rate", precision: 2 },
    {
      value: "AverageCellDiameter",
      label: "Average Cell Diameter",
      precision: 1,
    },
  ];

  const { data: rawData } = useFetch(
    `/spatialRun/${run?.runID}/wellSegmentationStats`,
    !!run?.runID
  );

  const data = (
    rawData?.WellCellSegmentationStats as {
      WellLocation: string;
      CellCount: number;
      CellConfluencyRate: number;
      NucleatedCellRate: number;
      AverageCellDiameter: number;
    }[]
  )?.map((v) => {
    const obj = {
      Well: v.WellLocation,
      Value: v[selectedField as keyof typeof v],
    };

    return obj;
  });

  console.log("data", data);

  const selectedFieldOption = fieldOptions.find(
    (option) => option.value === selectedField
  );

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        gap={2}
        style={{ marginTop: "20px", marginBottom: "20px" }}
      >
        <FormControl size="small" style={{ minWidth: 200 }}>
          <InputLabel id="field-select-label">Select Field</InputLabel>
          <Select
            labelId="field-select-label"
            value={selectedField}
            label="Select Field"
            onChange={(e) => setSelectedField(e.target.value)}
          >
            {fieldOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      {selectedField === "CellCount" && (
        <Typography variant="h6">Total Cells: {rawData?.CellCount}</Typography>
      )}

      <Chart dataSource={data} style={{ marginTop: "60px" }}>
        <Title horizontalAlignment="center" text={`${run?.runName}`} />
        <Size width="100%" />
        <Series
          argumentField="Well"
          valueField="Value"
          type="bar"
          barPadding={0}
        />
        <ValueAxis title={selectedFieldOption?.label || "Value"}>
          <Grid visible={true} />
        </ValueAxis>
        <ArgumentAxis title="Well">
          <Label wordWrap="none" overlappingBehavior="stagger" />
        </ArgumentAxis>
        <Export enabled />
        <Tooltip enabled>
          <Format
            type="fixedPoint"
            precision={selectedFieldOption?.precision}
          />
        </Tooltip>
        <Legend visible={false} />
      </Chart>
    </>
  );
};

export default CytoWellSegmentation;
